// 80 mm receipt CSS (spec §6.6), one source for the on-screen preview and the
// print iframe (a production build extracts SFC <style> into .css files the
// iframe cannot see, so the rules live here as a string).
export const POS_RECEIPT_CSS = `
.pos-receipt {
	width: 72mm;
	padding: 0 4mm;
	font: 13px/1.35 "Sarabun", "Kanit", sans-serif;
	color: #000;
	background: #fff;
	box-sizing: content-box;
}
.pos-receipt--screen {
	padding: 4mm;
	box-shadow: 0 1px 6px rgba(0, 0, 0, 0.18);
	margin: 0 auto;
}
.pos-receipt .pr-center {
	text-align: center;
}
.pos-receipt .pr-pre {
	white-space: pre-line;
}
.pos-receipt .pr-logo {
	max-width: 48mm;
	max-height: 30mm;
	filter: grayscale(1);
}
.pos-receipt .pr-shop {
	font-weight: 700;
	font-size: 16px;
}
.pos-receipt .pr-title {
	font-weight: 700;
	margin-top: 4px;
}
.pos-receipt .pr-void {
	display: inline-block;
	border: 1px solid #000;
	padding: 0 6px;
	font-weight: 700;
}
.pos-receipt .pr-rule {
	border-top: 1px dashed #000;
	margin: 4px 0;
}
.pos-receipt .pr-row {
	display: flex;
	justify-content: space-between;
}
.pos-receipt .pr-comp {
	padding-left: 10px;
	font-size: 12px;
}
.pos-receipt .pr-total {
	font-weight: 700;
	font-size: 18px;
}
.pos-receipt .pr-footer {
	margin-top: 6px;
}
.pos-receipt .pr-qr {
	width: 30mm;
	height: 30mm;
	margin-top: 4px;
}
`;

// `@page { size: 80mm auto }` is INVALID CSS (size takes two lengths, or one
// length for a square page): Chrome drops it and prints on Letter. The page
// is therefore sized from the measured receipt (posPrintPageSizeCss), with a
// static 80mm × 297mm fallback that is valid on its own.
export const POS_PAGE_WIDTH_MM = 80;
export const POS_PAGE_FALLBACK_HEIGHT_MM = 297;

export const POS_PRINT_PAGE_CSS = `
@page { size: 80mm 297mm; margin: 0 }
html, body { margin: 0; padding: 0; background: #fff; }
body { width: 80mm; }
`;

const PX_PER_MM = 96 / 25.4;

/** Receipt height in px (CSS px at 96 dpi) → page height in whole mm (+2 mm slack). */
export function posPageHeightMm(heightPx) {
	const h = Number(heightPx);
	if (!isFinite(h) || h <= 0) return POS_PAGE_FALLBACK_HEIGHT_MM;
	return Math.min(5000, Math.ceil(h / PX_PER_MM) + 2);
}

/** `@page` rule for an 80 mm roll cut to the measured receipt height. */
export function posPrintPageSizeCss(heightPx) {
	return `@page { size: ${POS_PAGE_WIDTH_MM}mm ${posPageHeightMm(heightPx)}mm; margin: 0 }`;
}

/** Inject POS_RECEIPT_CSS into document.head once. */
export function posEnsureReceiptCss(doc) {
	const d = doc || (typeof document !== "undefined" ? document : null);
	if (!d || d.getElementById("pos-receipt-css")) return;
	const el = d.createElement("style");
	el.id = "pos-receipt-css";
	el.textContent = POS_RECEIPT_CSS;
	d.head.appendChild(el);
}
